export const APP = {
    NAME: 'Repairs 4 Range Cookers'
}